import * as React from 'react'
import { SVGProps } from 'react'
const SvgPlayTo = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.794 14.461c.968.684.968 2.394 0 3.078l-9.256 6.54c-.968.684-2.178-.17-2.178-1.539V9.46c0-1.368 1.21-2.223 2.178-1.54l9.256 6.541Z"
      fill="currentColor"
    />
    <rect width={3.84} height={16.64} rx={1.92} transform="matrix(-1 0 0 1 24.96 7.68)" fill="currentColor" />
  </svg>
)
export default SvgPlayTo
